// ---Third-party imports
import { get } from 'ldash';
// ---Framework imports
import log from 'uix/logging';
import { handleActions, handleAction, handleSubState } from 'uix/actions';
import { persistReducer } from 'uix/persist';
// ---Local imports
import { runUploadImportOnIds, setUploadImportJob, setAnalyzedImport } from './actions';
// ---Exports
let uploadReducer = handleActions(new Map([
    [
        runUploadImportOnIds,
        ({ uploadImports, ...data_imp }, { payload })=>{
            return {
                ...data_imp,
                uploadImports: {
                    ...uploadImports,
                    [payload.txid]: null
                }
            };
        }
    ],
    [
        setUploadImportJob,
        ({ uploadImports, ...data_imp }, { payload })=>{
            return {
                ...data_imp,
                uploadImports: {
                    ...uploadImports,
                    [payload.txid]: payload.ojid
                }
            };
        }
    ],
    [
        setAnalyzedImport,
        ({ analyzer, ...data_imp }, { payload })=>{
            return {
                ...data_imp,
                analyzer: {
                    ...analyzer,
                    [payload.key]: payload.packages
                }
            };
        }
    ]
]), {
    uploadImports: {},
    analyzer: {}
});
export const data = [
    handleSubState('import', [
        persistReducer(uploadReducer, {
            key: 'uix_imports',
            whitelist: [
                'uploadImports'
            ]
        })
    ])
];
